import { useMemo, useState } from "react";
import { Slider } from "../ui/slider";

const usd = (n) => `$${Math.round(n).toLocaleString()}`;
const FEE = 25;

export const estimate = ({ sales, rate, avg, win }) => {
  const disputed = sales * (rate / 100);
  const count = disputed / avg;
  const fees = count * FEE;
  const lost = disputed * (1 - win / 100) + fees;
  const band = (newWin, intercept) => {
    const lift = Math.max(newWin - win, 0) / 100;
    return disputed * lift * 0.85 + count * intercept * FEE;
  };
  return { lost, count, low: band(Math.max(win, 50), 0.2), high: band(Math.max(win, 65), 0.35) };
};

const Field = ({ label, value, display, min, max, step, onChange, testid }) => (
  <div>
    <div className="flex justify-between text-sm"><span className="text-white/60">{label}</span><span className="font-mono text-white" data-testid={`${testid}-value`}>{display}</span></div>
    <Slider className="mt-3" value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)} data-testid={testid} />
  </div>
);

export const RoiCalculator = () => {
  const [f, setF] = useState({ sales: 2000000, rate: 12, avg: 2000, win: 20 });
  const r = useMemo(() => estimate(f), [f]);
  const set = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <div className="grid lg:grid-cols-2 gap-8 border border-white/10 bg-white/[0.02] p-6 md:p-10" data-testid="roi-calculator">
      <div className="space-y-7">
        <Field label="Annual sales" value={f.sales} display={usd(f.sales)} min={100000} max={20000000} step={100000} onChange={set("sales")} testid="roi-sales" />
        <Field label="Current chargeback rate" value={f.rate} display={`${f.rate}%`} min={0.5} max={25} step={0.5} onChange={set("rate")} testid="roi-rate" />
        <Field label="Average dispute amount" value={f.avg} display={usd(f.avg)} min={50} max={20000} step={50} onChange={set("avg")} testid="roi-avg" />
        <Field label="Your current win rate" value={f.win} display={`${f.win}%`} min={0} max={60} step={1} onChange={set("win")} testid="roi-win" />
      </div>
      <div className="flex flex-col justify-center">
        <p className="text-white/60 text-sm">You're losing about</p>
        <p className="text-4xl md:text-5xl font-extrabold text-[#F87171] font-mono" data-testid="roi-lost">{usd(r.lost)}<span className="text-lg text-white/40">/yr</span></p>
        <p className="text-white/60 text-sm mt-6">AEGIS Guard could save you, net of our 15% fee</p>
        <p className="text-4xl md:text-5xl font-extrabold text-brand font-mono" data-testid="roi-savings">{usd(r.low)}–{usd(r.high)}<span className="text-lg text-white/40">/yr</span></p>
        <p className="text-sm text-white/55 mt-6">How: across ~{Math.round(r.count).toLocaleString()} disputes a year, we lift win rates toward 50–65% with consent and delivery proof, and intercept 20–35% of disputes before they're filed, avoiding ~${FEE} in fees each.</p>
        <p className="text-[11px] text-white/35 mt-3">Illustrative estimate, not a guarantee. Results vary by vertical, evidence quality and issuer.</p>
      </div>
    </div>
  );
};
